//
// Module for the Seminars index page
//
rs.module("content/seminarattendance/index",

    ["controls/data/grid"],

    function (gridModule) {

        function initialize(jsSelectors, backendUrls, seminarGrid) {
            var addLink = $.js(jsSelectors.addLink);

            var popup = $.js(jsSelectors.popup);
            var popupCloseButton = $.js(jsSelectors.popupCloseButton);

            // Trigger search when search button is clicked
            addLink.click(function () {
                popup.modal("show");
            });

            // Hide only this modal on close.
            popupCloseButton.on('click', function () {
                // hide the popup 
                popup.modal("hide");
            });

            // On search results row clicked, populates the search control with selected participant
            seminarGrid.selectionChanged(function (values, rows) {

                // need to make sure values is greater than zero because grid.selectionChanged fires when grid is first rendered
                if (values.length > 0) {
                    redirectToSeminarAttendanceAddUrl(values[0])
                }
            });

            //
            // Redirect to seminar attendance add
            //
            function redirectToSeminarAttendanceAddUrl(seminarKey) {
                $.getJSON(
                    backendUrls.seminarAttendanceAddUrl,

                    {
                        seminarKey: seminarKey
                    },

                    function (data) {
                        window.location.href = data.seminarAttendanceAddUrl;
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);